import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { apisDataCacheKeys } from "@app-constants/app.constants";
import { TenantConstant } from "@app-constants/tenant.constant";
import { environment } from "@app-environments/environment";
import { id } from "date-fns/locale";
import { Observable, throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { clearLocalStorage } from "src/app/helpers/functions";


@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {
    
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const token: any = localStorage.getItem('token');
        //const studentId: any = (localStorage.getItem('mobile_and_name'));
        // const accesstoken: any = localStorage.getItem('accesstoken');
        const tenantFromUrl = localStorage.getItem('tenantFromUrl');
        const selectedTab = localStorage.getItem('SelectedTab');
        if(request.url.includes(environment.SELF_LEARN_API) ){
            request = JSON.parse(localStorage.getItem(apisDataCacheKeys?.userDetails))?.subTenant != null ? request.clone({ headers: request.headers.set('subTenantId', JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails))?.subTenant.toString()) }): request.clone({ headers: request.headers.delete('subTenantId')});
            request =  JSON.parse(localStorage.getItem(apisDataCacheKeys?.userDetails))?.tenantId != null ? request.clone({ headers: request.headers.set('tenantId', JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails))?.tenantId.toString()) }) : request.clone({ headers: request.headers.delete('tenantId') });;
        }
        if(request.url.includes(environment.GOAL_SETTING_URL) ){
            request = JSON.parse(localStorage.getItem(apisDataCacheKeys?.userDetails))?.subTenant != null ? request.clone({ headers: request.headers.set('subTenantId', JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails))?.subTenant.toString()) }): request.clone({ headers: request.headers.delete('subTenantId')});
            request =  JSON.parse(localStorage.getItem(apisDataCacheKeys?.userDetails))?.tenantId != null ? request.clone({ headers: request.headers.set('tenantId', JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails))?.tenantId.toString()) }) : request.clone({ headers: request.headers.delete('tenantId') });;
        }
        
        const tenant : any = (tenantFromUrl == 'iltsc' && selectedTab == 'subscribedPackages' || selectedTab == 'enrollnow') ? 'ILTSC' : TenantConstant.tenant;
        if (token && !request.url.includes('api/selflearn/getMapping')) {
            request = request.clone({ headers: request.headers.set('Authorization', 'Bearer ' + token) });
            // request = request.clone({ headers: request.headers.set('accesstoken', token) });
            // request = request.clone({ headers: request.headers.set('studentid', studentId?.mobile) });
        }

        if(!token || token === 'undefined' || token==='') {
            request = request.clone({ headers: request.headers.set('Authorization', 'Bearer') });
        }

        if(!request.url.includes('api/selflearn/getMapping')){
            request = request.clone({ headers: request.headers.set('X-Tenant', tenant) });
            request = request.clone({ headers: request.headers.set('ot-tenant', tenant) });
            request = request.clone({ headers: request.headers.set('X-Platform', 'web') });
            request = request.clone({ headers: request.headers.set('X-DeviceId', localStorage.getItem('deviceIp') || "127.0.0.1") });
        }
        // request = request.clone({ params: request.params.append('X-Tenant', tenant) });

        // if (!request.headers.has('Content-Type')) {
        //     request = request.clone({ headers: request.headers.set('Content-Type', 'application/json') });
        // }

        // request = request.clone({ headers: request.headers.set('Accept', '**') });

        // if(request.headers.has('Accept')) {
        //     request = request.clone({headers: request.headers.set('Accept', '**')})
        // }

        return next.handle(request).pipe(
            catchError((err) => {
                console.log('err: ', err);
                let referralCode=JSON.parse(localStorage.getItem('reffCode'));
                let pname=localStorage.getItem('pgName');
                if(referralCode && pname=='votp'){
                //   console.log('refCode Present!');
                //   console.log({asaaaas:pname});
                  let refUrl=window.location.origin+`/signup?referralCode=${referralCode.referralCode}`
                //   this.router.navigateByUrl('/signup');
                window.location.href = refUrl;
                }else if(err?.status == 403){
                    clearLocalStorage();
                    if(window.location.pathname  == '/diagnostic-test'){
                            window.location.href = window.location.origin+'/diagnostic-test'
                    }else if(window.location.pathname  == '/goal-setting'){

                    }
                    else{
                        window.location.href = window.location.origin;
                    }

                }
                
                return throwError(err);
            }),
            map((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {
                    // console.log('event--->>>', event);
                }
                return event;
            }));
    }
}
